export default {
  errors: null,
  clients: [],
  loading: false,
  count: 0,
  totalCount: 0,
  downloadList:[]

};
